import React from "react";
import Radium, { StyleRoot } from "radium";
import {
  SectionTitle,
  AnimatedList,
  Card,
  Button,
  Form,
  SimpleCarousel,
} from "tomo-react-components";
import { mobileTestimonialDecorators, desktopDecorators } from "./decorators";
import TestimonialContent from "./TestimonialContent";
import FactsCarousel from "./FactsCarousel";
import FactsBoard from "./FactsBoard";
import data from "../data";
import styles from "../styles/partnersContainer";

class PartnersContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: window.matchMedia("(max-width: 767px)").matches,
      tablet: window.matchMedia("(max-width: 768px)").matches,
      slidesToShow: window.matchMedia("(max-width: 1000px)").matches ? 1 : 2,
    };
  }

  componentDidMount() {
    // navigation click actions
    $(".navbar-submenu-link").on("click", function (event) {
      event.preventDefault();
      var sectionID = $(this).attr("href");
      scrollToID(sectionID, 300);
      $(this).blur();
    });
    // scroll function
    function scrollToID(id, speed) {
      if (id === "#") {
        return;
      }
      var offSet = 80;
      var targetOffset = $(id).offset().top - offSet;
      $("html,body").animate({ scrollTop: targetOffset }, speed);
    }

    window.addEventListener("resize", () => {
      if (window.matchMedia("(max-width: 767px)").matches) {
        this.setState({
          mobile: true,
          tablet: true,
          slidesToShow: 1,
        });
      } else if (window.matchMedia("(max-width: 768px)").matches) {
        this.setState({
          mobile: true,
          tablet: true,
          slidesToShow: 1,
        });
      } else if (window.matchMedia("(max-width: 1200px)").matches) {
        this.setState({
          mobile: false,
          tablet: false,
          slidesToShow: 1,
        });
      } else {
        this.setState({
          mobile: false,
          tablet: false,
          slidesToShow: 2,
        });
      }
    });

    const iframe_header = $("#video_player")[0];
    const video_player = $(iframe_header);

    $("#play_btn").on("click", () => {
      video_player.api("play");
      $("#video_player").show();
      $("#video_thumb").hide();
      $("#play_btn").hide();
    });
  }

  render() {
    return (
      <div style={styles.container}>
        <div id="whoweare" />
        <div style={styles.card.wrapper}>
          <StyleRoot>
            <Card.component
              customStyles={{
                backgroundPosition: "50% 35%",
              }}
              imageUrl={
                "https://cdn-s3.touchofmodern.com/partners/assets/hdrImg_intro.jpg"
              }
              padding={"200px 50px"}
            >
              <div
                style={[styles.card.title, styles.card.titleDimension1]}
                role={"heading"}
                aria-level={"1"}
              >
                Partner With Touch of Modern
              </div>
            </Card.component>
          </StyleRoot>
        </div>
        <Card.component
          backgroundColor={"#252528"}
          padding={"0 0 40px"}
          width={"100%"}
        >
          <div style={[styles.card.content, styles.card.margin]}>
            <div style={styles.firstParagraph}>
              Our success — in fact our entire business — is built on
              relationships. We partner with brands of all sizes to market and
              sell their incredible products to our 16M registered members.
            </div>
          </div>
          <a className="navbar-submenu-link" href="#partnerwithus">
            <Button.component
              width="200px"
              height="40px"
              color="#252528"
              backgroundColor="#fff"
              hoverBackgroundColor="#ddd"
              borderColor="transparent"
              fontWeight="400"
            >
              partner with us
            </Button.component>
          </a>
        </Card.component>
        <div id="facts" />
        {this.state.tablet ? <FactsCarousel /> : <FactsBoard />}
        <div id="whatwedo" />
        <div style={styles.card.wrapper}>
          <StyleRoot>
            <Card.component
              imageUrl={
                "https://cdn-s3.touchofmodern.com/partners/assets/hdrImg_what.jpg"
              }
              customStyles={{
                padding: "40px 30px",
                "@media (min-width: 768px) and (max-width: 768px)": {
                  padding: "40px 90px",
                },
              }}
            >
              <div style={styles.card.horizontallyAlignedContainer}>
                <div style={[styles.card.title, styles.card.titleDimension2]}>
                  <div
                    style={styles.secondParagraph}
                    role={"heading"}
                    aria-level={"1"}
                  >
                    What{this.state.tablet ? " " : <br />}we do
                  </div>
                  <hr style={styles.card.hr} />
                </div>
                <div
                  style={[
                    styles.card.content,
                    styles.card.horizontallyAlignedContent,
                  ]}
                >
                  <div style={styles.card.contentParagraph}>
                    We connect with the creators, distributors, and
                    manufacturers of the most impressive products in the men’s
                    lifestyle space. Through careful curation and expert
                    merchandising, our team works closely with each brand to
                    transform their products into a one-of-a-kind retail
                    experience. This makes us the preferred product launch
                    platform for our partners and allows our 16M registered
                    members to discover new brands every day.
                  </div>
                </div>
              </div>
            </Card.component>
          </StyleRoot>
        </div>
        <div id="howwework" />
        <StyleRoot>
          <div
            style={styles.sectionTitleWrapper}
            role={"heading"}
            aria-level={"1"}
          >
            <SectionTitle.component
              wrapperCustomStyle={{ marginTop: "70px" }}
              title="Our team"
            />
          </div>
        </StyleRoot>
        <StyleRoot>
          <AnimatedList.component contents={data.animatedList} />
        </StyleRoot>
        <div id="testimonials" />
        <Card.component
          backgroundColor="#252528"
          padding="0 0 10px"
          width="100%"
        >
          <StyleRoot>
            <div
              style={styles.sectionTitleWrapper}
              role={"heading"}
              aria-level={"1"}
            >
              <SectionTitle.component
                wrapperCustomStyle={{
                  margin: "70px 0px 10px",
                }}
                title="What our vendors say about us"
                titleColor="#fff"
              />
            </div>
          </StyleRoot>
          <StyleRoot>
            <div style={styles.testimonialsWrapper}>
              <div style={styles.space30} />
              <SimpleCarousel.component
                slidesToScroll={this.state.slidesToShow}
                slidesToShow={this.state.slidesToShow}
                slideWidth={1}
                cellAlign="left"
                autoplay={this.state.tablet ? true : false}
                decorators={
                  this.state.tablet
                    ? mobileTestimonialDecorators
                    : desktopDecorators
                }
                carouselCardHeight="400px"
                carouselCardBorder="none"
                carouselCardAlignItems="stretch"
                contents={data.brands.map((brandData, i) => {
                  return {
                    cardContent: (
                      <TestimonialContent
                        brand={brandData.brand}
                        person={brandData.person}
                        company={brandData.company}
                        description={brandData.description}
                      />
                    ),
                  };
                })}
              />
            </div>
          </StyleRoot>
          <StyleRoot>
            <div style={styles.card.subTitle}>
              Join our growing list of brands
            </div>
            <div style={styles.brandWrapper}>
              {data.brandList.map((brand, i) => (
                <StyleRoot key={i}>
                  <img
                    src={`https://cdn-s3.touchofmodern.com/partners/assets/BrandLogo_${brand}.png`}
                    style={styles.brand}
                    alt={`${brand}`}
                  />
                </StyleRoot>
              ))}
            </div>
          </StyleRoot>
        </Card.component>
        <div id="partnerwithus" />
        <StyleRoot>
          <Form.component maxWidth="700px" padding="20px 20px 50px" />
        </StyleRoot>
      </div>
    );
  }
}

export default Radium(PartnersContainer);
